<template>
  <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
       aria-labelledby="productModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="max-width: 800px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="productModalLabel">{{ clientName }}</h5>
          <b-button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    @click="setClientShowData(false)">
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <div class="modal-body">
          <h6>Персональные данные</h6>
          <div v-if="this.clientLoadData">
            <CircleProgress/>
          </div>
          <div v-if="!this.clientLoadData" style="display: flex; justify-content: space-between">
            <div class="left-side" style="width: 50%; padding-right: 20px;">
              <label for="passportNumber" style="font-weight: bold;">Номер паспорта</label>
              <argon-input
                  id="passportNumber"
                  :value="personalData.passportNumber"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <div class="input-container">
                <label for="birthdate">Дата выдачи</label>
                <input
                    id="passportIssueDate"
                    :value="personalData.passportIssueDate != null ? personalData.passportIssueDate.split('T')[0] : null"
                    type="date"
                    @focusin="toggleReadonly"
                    @focusout="toggleReadonly"
                    :readonly="true"
                />
              </div>

              <div class="input-container" style="margin-top: 16px;">
                <label for="passportAuthor">Орган выдавший паспорт</label>
                <select
                    id="passportAuthor"
                    style="max-width: 100%;  border: 1px solid #d2d6da;
                              color: #495057;
                              border-radius: 0.5rem;
                              font-size: 0.85rem;
                              padding: 0.5rem 0.75rem;"
                    :value="personalData.passportIssuingAuthorityId"
                    disabled
                >
                  <option :key="null" :value="null">
                    Не выбрано
                  </option>
                  <option v-for="item in passportAuthors" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <div v-if="this.passportScan" class="input-container" style="margin-top: 16px;">
                <label for="passportNumber" style="font-weight: bold;">Скан паспорта</label>
                <div style="width: 200px; height: 100px; overflow: hidden; position: relative">
                  <img :src="this.passportScan" alt="Превью изображения" style="max-width: 100%; object-fit: cover;">
                </div>
              </div>

              <label for="registrationAddress" style="font-weight: bold; margin-top: 16px;">Адрес регистрации</label>
              <argon-input
                  id="registrationAddress"
                  :value="personalData.registrationAddress"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="address" style="font-weight: bold;">Адрес проживания</label>
              <argon-input
                  id="address"
                  :value="personalData.address"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
            </div>

            <div class="right-side" style="width: 50%; padding-left: 20px;">
              <label for="phone" style="font-weight: bold;">Номер телефона</label>
              <argon-input
                  id="phone"
                  :value="personalData.phone"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="email" style="font-weight: bold;">E-mail</label>
              <argon-input
                  id="email"
                  :value="personalData.email"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
              <label for="additionalPhone" style="font-weight: bold;">Дополнительный номер телефона</label>
              <argon-input
                  id="additionalPhone"
                  :value="personalData.additionalPhone"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />

              <label for="workInfo" style="font-weight: bold;">Дополнительная информация</label>
              <argon-input
                  id="workInfo"
                  :value="personalData.workInfo"
                  @focusin="toggleReadonly"
                  @focusout="toggleReadonly"
                  :readonly="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ArgonInput from "../../../components/ArgonInput.vue";
import axios from "@/axios";
import CircleProgress from "../CircleProgress.vue";

export default {
  name: 'ClientPersonalInfo',
  components: {CircleProgress, ArgonInput},
  data() {
    return {
      passportAuthors: [],
      passportScan: null
    };
  },
  props: {},
  computed: {
    personalData: {
      get() {
        return this.$store.state.clientPersonalData;
      },
    },
    showModal: {
      get() {
        return this.$store.state.clientShowData;
      }
    },
    clientLoadData: {
      get() {
        return this.$store.state.clientLoadData;
      }
    },
    clientName: {
      get() {
        return this.$store.state.currentClientName;
      }
    }

  },
  methods: {

    toggleReadonly(event) {
      event.preventDefault();
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly');
      } else {
        event.target.setAttribute('readonly', 'readonly');
      }
    },
    fetchPassportAuthors() {
      axios.get('/api/clients/pasport_autors').then(response => {
        this.passportAuthors = response.data;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },

    fetchPassportScan() {
      axios.get('/api/clients/' + this.personalData.clientId + '/passport-scan').then(response => {
        this.passportScan = "data:image/jpeg;base64," + response.data.passport_scan;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },

    setClientShowData(active) {
      this.$store.commit('updateClientShowData', active);
    },
    setClientLoadData(active) {
      this.$store.commit('updateClientLoadData', active);
    }

  },
  mounted() {
    this.setClientShowData(true);
    this.fetchPassportAuthors();
    if (this.personalData.passportScan != null) {
      this.fetchPassportScan();
    }
    this.setClientLoadData(false);
  },
}
</script>

<style scoped>

#passportIssueDate {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  display: flex;
  flex-direction: column;
}

</style>
